import Image from 'next/image';
import Link from 'next/link';
import { FC } from 'react';

import { getStoryblokImageUrl } from '@/lib/utils';

import PreHeading from '../PreHeading';

export interface SpotlightProps {
  posts: [];
  title: string;
}

const Spotlight: FC<SpotlightProps> = ({ posts, title }) => {
  return (
    <>
      <PreHeading
        size=""
        element="h3"
        color="text-theme-darkgrey"
        className="mb-4 grid grid-cols-[auto_1fr] gap-2 align-middle text-[0.8rem] font-extralight tracking-widest text-theme-darkgrey lg:mb-6"
      >
        {title}
        <div className="h-px bg-theme-midgrey/20"></div>
      </PreHeading>
      <div className="grid gap-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 lg:gap-6">
        {posts.map((p: any) => {
          return (
            <Link
              key={p.uuid}
              href={`/staff#${p.name.replace(' ', '_')}`}
              className="group relative overflow-hidden"
              >
                <>
              <Image
                src={getStoryblokImageUrl(
                  p.content?.hero_feature_image?.filename,
                  800,
                  0
                )}
                alt={p.name}
                fill
                className="absolute object-cover duration-1000 group-hover:scale-110"
              />
              <div
                className="relative flex aspect-[4/3] items-end p-2 px-4 text-theme-darkgrey"
                style={{
                  backgroundImage: `radial-gradient(83.69% 83.69% at 16.88% 100%, #282828 0%, rgba(40, 40, 40, 0) 100%)`,
                  backgroundSize: 'cover, cover',
                }}
              >
                <span className="self-end font-semibold text-white">
                  {p.name}
                </span>
              </div>
              </>
            </Link>
          );
        })}
      </div>
    </>
  );
};

export default Spotlight;
